export default "/Frontend/dist/ppt.e20a7876416b11ab04264ad24b8bb601.svg";